// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .logo-img{
    border-right: 1px solid #fff;
    padding-right: 15px;
    margin-right: 10px;
}
.Sign-out{
    color: rgba(255,255,255,.5);
    line-height:40px;
    padding: 0 15px
}

.Sign-out :hover{
    text-decoration: none;
} */


.pop-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5%;
  }

span.kt-header__topbar-username.kt-hidden-mobile {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block !important;
}



.text-white label {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    white-space: nowrap;
}
.kt-header__topbar .kt-header__topbar-item .text-white.kt-header__topbar-icon {
    width: auto;
    margin: 0 !important;
    padding: 15px;
}

span.kt-header__topbar-username.kt-hidden-mobile {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block !important;
}


.kt-aside__brand .kt-aside__brand-logo a:after {
    content: "" !important;
}


`, "",{"version":3,"sources":["webpack://./src/app/views/main/main.component.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;GAaG;;;AAGH;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;;AAEF;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;;;AAIA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;;AAGA;IACI,sBAAsB;AAC1B","sourcesContent":["/* .logo-img{\r\n    border-right: 1px solid #fff;\r\n    padding-right: 15px;\r\n    margin-right: 10px;\r\n}\r\n.Sign-out{\r\n    color: rgba(255,255,255,.5);\r\n    line-height:40px;\r\n    padding: 0 15px\r\n}\r\n\r\n.Sign-out :hover{\r\n    text-decoration: none;\r\n} */\r\n\r\n\r\n.pop-buttons {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: 5%;\r\n  }\r\n\r\nspan.kt-header__topbar-username.kt-hidden-mobile {\r\n    max-width: 120px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block !important;\r\n}\r\n\r\n\r\n\r\n.text-white label {\r\n    max-width: 120px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    margin: 0;\r\n    white-space: nowrap;\r\n}\r\n.kt-header__topbar .kt-header__topbar-item .text-white.kt-header__topbar-icon {\r\n    width: auto;\r\n    margin: 0 !important;\r\n    padding: 15px;\r\n}\r\n\r\nspan.kt-header__topbar-username.kt-hidden-mobile {\r\n    max-width: 120px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block !important;\r\n}\r\n\r\n\r\n.kt-aside__brand .kt-aside__brand-logo a:after {\r\n    content: \"\" !important;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
